import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../StyleSheet/MainComponent/DashBoard/DashBoard.scss";
import Select from "react-dropdown-select";
import {
  SetTheDashboardClientList,
  SetTheDashboardOrganizationListed,
  setTheEmployeeeStateName,
  setTheEmployeeregionName,
  setTheEmployeeZoneName,
} from "../../../Redux/Slice";
import { DateRangePicker } from "rsuite";
import { addDays, endOfWeek, isAfter, startOfWeek, subDays } from "date-fns";
import dayjs from "dayjs";
import "./newDashboard.scss";
import onBoardProfileWhiteIcon from "../../../Assets/NewDashboardAssets/onboardProfileWhiteIcon.svg";
import onBoardProfileBlueIcon from "../../../Assets/NewDashboardAssets/onboardProfileBlueIcon.svg";
import NewDashCmpletedIocn from "../../../Assets/NewDashboardAssets/NewDashCmpletedIocn.svg";
import NewDashExitIocn from "../../../Assets/NewDashboardAssets/NewDashExitIcon.svg";
import NewDashPendingIocn from "../../../Assets/NewDashboardAssets/NewDashPendingIcon.svg";
import NewDashDeclineIcon from "../../../Assets/NewDashboardAssets/NewDashDeclineIcon.svg";
import { id } from "date-fns/locale";
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  Sector,
  Tooltip,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  ReferenceLine,
  Dot,
} from "recharts";

const CustomDot = ({ cx, cy }) => {
  return (
    <>
      {/* vertical guide line */}
      <line x1={cx} y1={40} x2={cx} y2={350} stroke="#b5c1cc" strokeWidth={2} />

      {/* orange data point */}
      <circle cx={cx} cy={cy} r={6} fill="#e64a19" />

      {/* top blue dot */}
      <circle cx={cx} cy={40} r={6} fill="#1b4c72" />
    </>
  );
};

const NewDashboard = () => {
  const RoleBased = useSelector((state) => state.SideBarFiles.Role);
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [filterForWhite, setFilters] = useState({ white_collar: "" });
  const [startDateRange, setStartDate] = useState(null);
  const [onBoardTabs, setOnBoardTabs] = useState("Total Employees");
  const [activeIndex, setActiveIndex] = useState(null);
  const [graph, setGraph] = useState(false);
  const onPieEnter = (_, index) => {
    setActiveIndex(index);
  };
  const onPieLeave = () => {
    setActiveIndex(null);
  };
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  let [nameList, setOptions] = useState([]);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    Clientsearch: "",
    organization_search: "",
  };
  const [SearchDebounance, setSearchDebounance] = useState(
    initialDebouanceSearch,
  );
  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    organization_search: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const [multiselect, setMuliselect] = useState([
    state.ClientBranchIDs.EmployeeListState,
  ]);
  const [multiselect1, setMuliselect1] = useState([
    // { value: "", label: "All" },
    // state.ClientBranchIDs.RegionName,
    state.ClientBranchIDs.EmployeeRegion,
  ]);
  const [multiselect3, setMuliselect3] = useState([
    // { value: "", label: "All" },
    // state.ClientBranchIDs.ZoneName,
    state.ClientBranchIDs.EmployeeZone,
  ]);
  const [Client, setClients] = useState("");
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [Organization_Val, setOrganization_Val] = useState(
    state?.DashboardCall?.DashboardOrganizationSelcetdList,
  );
  const [Filterids, setfilterids] = useState({
    organization: state?.DashboardCall?.DashboardOrganizationSelcetdList?.value,
  });
  const dateRangeRef = useRef(null);

  const [Organization_options, setOrganizations_options] = useState([]);
  const [employeVerify, setempVer] = useState(0);
  const [declineemp, setDeclineEmp] = useState(0);
  const [PendingEmp, setPendignEmp] = useState(0);
  const [count, setCount] = useState(0);

  ///-------for the -----counts based
  const [pendingCounts, setPendingCounts] = useState(0);
  const [DeclineCounts, setDeclineCount] = useState(0);
  const [EployeeVerifiy, setEmpVerifyed] = useState(0);
  const [FindZeroticket, setFindZeroTickets] = useState(false);
  const [clientname, setClientName] = useState();

  const [datas, setData] = useState({
    // zone: state.ClientBranchIDs.ZoneName.value,
    // state: state.ClientBranchIDs.StateName.value,
    // region: state.ClientBranchIDs.RegionName.value,

    zone: state.ClientBranchIDs.EmployeeZone?.value,
    state: state.ClientBranchIDs.EmployeeListState?.value,
    region: state.ClientBranchIDs.EmployeeRegion?.value,
  });
  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(today);

  var st = convert(state.EmployeeVerificationsNeed.FROMDATE);
  var et = convert(state.EmployeeVerificationsNeed.TODATE);

  const [nameList4, setOptions4] = useState([]);
  const [selectedValues, SetSelectValue] = useState([]);
  const today_day = dayjs().format("YYYY-MM-DD");
  const [datestae, setdatest] = useState(false);
  const [datefilter, setdatefilter] = useState({
    from_date: gt,
    to_date: it,
    range: true,
  });
  const [range, setrange] = useState(
    state.EmployeeVerificationsNeed.FROMDATE == ""
      ? // [it, gt]
        [today_day, today_day]
      : [st, et],
  );

  const getZoomFactor = () => {
    const zoom = document.body.style.zoom;
    return zoom ? parseFloat(zoom) / 100 : 1;
  };
  useEffect(() => {
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.GeoState.State.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.state_name.toUpperCase(),
        });
      });

      // console.log(objectArray , "objectArray");
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);

  useEffect(() => {
    const Datas = [];

    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
        });
      });

      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);

  const handleInputOrganization = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      organization_search: Val,
    });
  };

  useEffect(() => {
    if (state.organization_filterlist_tocall.Organization_filterlist_records) {
      let ObjectArrayFormager = [];
      ObjectArrayFormager.push({
        value: "",
        label: "ALL",
      });
      state.organization_filterlist_tocall.Organization_filterlist_records.forEach(
        (element) => {
          ObjectArrayFormager.push({
            value: element.id,
            label: element.organization_name,
          });
        },
      );
      setOrganizations_options(ObjectArrayFormager);
    }
  }, [
    state.organization_filterlist_tocall.Organization_filterlist_records,
    SearchedVal.organization_search,
  ]);

  const HandleInputBranch = (e) => {
    setSearchDebounance({
      ...SearchDebounance,
      Clientsearch: e,
    });
  };

  useEffect(() => {
    if (state.BranchSearchpart.BranchSearch != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.BranchSearchpart.BranchSearch.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.branch_code
            ? `${element.branch_code}-${element.client_name.toUpperCase()}`
            : element.client_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.BranchSearchpart.BranchSearch, search]);

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
    // {
    //   label: "Next week",
    //   closeOverlay: false,
    //   value: (value, index) => {
    //     console.log(value);
    //     const [start = new Date()] = value[index] || [];
    //     return [
    //       addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
    //       addDays(endOfWeek(start, { weekStartsOn: 0 }), 7),
    //     ];
    //   },
    //   appearance: "default",
    // },
  ];

  const handlechangedate = (value) => {
    console.log(value, "vlues");
    // if (value != null) {
    //   setrange((oldArray) => [...oldArray, d.slice(0, 10)]);
    // }

    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
      // setSelectedDates(value);
      setdatest(true);
      // value.forEach((newValue) => {
      //   const tzoffset = new Date().getTimezoneOffset() * 60000;
      //   const localISOTime = new Date(newValue - tzoffset)
      //     .toISOString()
      //     .slice(0, -1);
      //   // handle the start and end dates here
      // });

      setdatefilter({
        ...datefilter,
        from_date: range[0],
        to_date: range[1],
        range: true,
      });

      // console.log(datefilter, "datefilter");
    }
  };
  const alignDateRangePicker = (pickerNode) => {
    const picker = pickerNode?.root || pickerNode?.container || pickerNode;

    const popup = document.querySelector(
      ".rs-picker-popup.rs-picker-popup-daterange",
    );

    if (!picker || !popup) return;

    const zoom = getZoomFactor();
    const rect = picker.getBoundingClientRect();

    const popupWidth = popup.offsetWidth;
    const popupHeight = popup.offsetHeight;

    const viewportWidth = window.innerWidth / zoom;
    const viewportHeight = window.innerHeight / zoom;

    const scrollX = window.scrollX / zoom;
    const scrollY = window.scrollY / zoom;

    let left = rect.right / zoom - popupWidth + scrollX;
    let top = rect.bottom / zoom + 8 + scrollY;

    if (left < 8) left = 8;
    if (left + popupWidth > viewportWidth - 8) {
      left = viewportWidth - popupWidth - 8;
    }

    if (top + popupHeight > viewportHeight + scrollY - 8) {
      top = rect.top / zoom - popupHeight - 8 + scrollY;
    }

    popup.style.position = "absolute";
    popup.style.left = `${left}px`;
    popup.style.top = `${top}px`;
  };

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };
  const handleInputChange = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      stateSearch: Val,
    });
  };
  const handleSelectChange = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      setData({
        ...datas,
        state: selectedVal.value,
        zone: "",
        region: "",
      });
      dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));

      setClients("");

      dispatch(setTheEmployeeeStateName(selectedVal));
      dispatch(setTheEmployeeregionName({ value: "", label: "ALL" }));

      dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...datas,
        state: "",
        zone: "",
        region: "",
      });
      setClients("");

      dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));

      dispatch(setTheEmployeeeStateName({ value: "", label: "ALL" }));
      dispatch(setTheEmployeeregionName({ value: "", label: "ALL" }));

      dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));
    }
  };
  const handleInputRegion = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      regionSearch: Val,
    });
  };

  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setTheEmployeeregionName(selectedVal));
      dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));

      setData({
        ...datas,
        region: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setData({
        ...datas,
        region: "",
        zone: "",
      });

      dispatch(setTheEmployeeregionName({ value: "", label: "ALL" }));
      dispatch(setTheEmployeeZoneName({ value: "", label: "ALL" }));

      setMuliselect3({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
    }
  };

  const handlOrganizationList = (selected) => {
    if (selected != null) {
      dispatch(SetTheDashboardOrganizationListed(selected));
      setOrganization_Val(selected);
      setfilterids({
        ...Filterids,
        organization: selected?.value,
      });
    } else {
      dispatch(SetTheDashboardOrganizationListed({ value: "", label: "ALL" }));
      setOrganization_Val({ value: "", label: "ALL" });
      setfilterids({
        ...Filterids,
        organization: "",
      });
    }
    setempVer(0);
    setCount(0);
    setPendignEmp(0);
    setDeclineEmp(0);
    ////counts
    setPendingCounts(0);
    setClients("");
    setClientName("");
    setEmpVerifyed(0);
    setDeclineCount(0);

    dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
  };

  const HandleClientBranches = (selectedVal) => {
    //  console.log(selectedVal, "selectedvalue", counts);

    if (selectedVal != null) {
      dispatch(SetTheDashboardClientList(selectedVal));
      SetSelectValue(selectedVal);
      //  console.log("in Search");
      setClients(selectedVal.value);
      SetSelectValue(selectedVal);
      setClientName(selectedVal.label);
    } else if (selectedVal == null) {
      setempVer(0);
      setCount(0);
      setPendignEmp(0);
      setDeclineEmp(0);

      ////counts
      setPendingCounts(0);

      setEmpVerifyed(0);
      setDeclineCount(0);
      setClients("");
      SetSelectValue({ value: "", label: "ALL" });
      setClientName("");
      dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
    }
  };

  const leftOnboardCards = [
    {
      id: 1,
      title: "Completed",
      icon: NewDashCmpletedIocn,
      count: 500,
    },
    {
      id: 2,
      title: "Decline",
      icon: NewDashDeclineIcon,
      count: 530,
    },
    { id: 3, title: "Pending", icon: NewDashPendingIocn, count: 90 },
    {
      id: 4,
      title: "Exit",
      icon: NewDashExitIocn,
      count: 200,
    },
  ];
  const rightOnboardCards = [
    {
      id: 1,
      title: "Present",
      icon: NewDashCmpletedIocn,
      count: 500,
    },
    {
      id: 2,
      title: "Absent",
      icon: NewDashDeclineIcon,
      count: 530,
    },
  ];
  const onBoardStateList = [
    {
      id: 1,
      state: "Tamil Nadu",
      employees: "400",
    },
    { id: 2, state: "Kerala", employees: "400" },
    { id: 3, state: "Karnataka", employees: "400" },
    { id: 4, state: "Kerala", employees: "400" },
    { id: 5, state: "Kerala", employees: "400" },
    { id: 6, state: "Kerala", employees: "400" },
  ];
  const chartColorList = [
    "rgba(201, 84, 40, 1)",
    "rgba(245, 173, 20, 1)",
    "rgba(216, 18, 21, 1)",
    "rgba(17, 124, 68, 1)",
  ].reverse();

  const onBoardAbsentList = [
    {
      id: 1,
      state: "Tamil Nadu",
      percentage: "45%",
    },
    { id: 2, state: "Kerala", percentage: "40%" },
    { id: 3, state: "Karnataka", percentage: "80%" },
    { id: 4, state: "Kerala", percentage: "4%" },
    { id: 5, state: "Kerala", percentage: "24%" },
    { id: 6, state: "Kerala", percentage: "4%" },
    { id: 2, state: "Kerala", percentage: "40%" },
    { id: 3, state: "Karnataka", percentage: "80%" },
    { id: 4, state: "Kerala", percentage: "6%" },
    { id: 5, state: "Kerala", percentage: "47%" },
    { id: 6, state: "Kerala", percentage: "4%" },
  ];

  const graphData = [
    {
      name: "Completed",
      pv: 25,
    },
    {
      name: "Decline",
      pv: 10,
    },
    {
      name: "Pending",
      pv: 15,
    },
    {
      name: "Exit",
      pv: 50,
    },
  ];
  const renderActiveShape = (props) => {
    const {
      cx,
      cy,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      fill,
      payload,
    } = props;
    return (
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius + 10} // Increase radius on hover
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
        style={{ transition: "all 0.5s ease-in-out" }}
      />
    );
  };

  const data = [
    { day: "Monday", value: 0 },
    { day: "Tuesday", value: 50 },
    { day: "Wednesday", value: 60 },
    { day: "Thursday", value: 65 },
    { day: "Friday", value: 50 },
    { day: "Saturday", value: 45 },
    { day: "Sunday", value: 65 },
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div
          style={{
            background: "#fff",
            border: "1px solid #ccc",
            padding: "3px",
            borderRadius: "6px",
            boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",

            backgroundColor: "rgb(239, 239, 239)",

            fontSize: "12px",
            display: "flex",
            gap: "10px",
          }}
        >
          <p style={{ margin: 0, fontWeight: 500 }}>{data.name} :</p>
          <p style={{ margin: 0 }}>
            <strong>{data.pv}</strong>
          </p>
          {/* If percentage is needed, you can add it here */}
        </div>
      );
    }

    return null;
  };
  const renderLegend = (props) => {
    const { payload } = props;

    const uniqueNames = new Set();
    const filteredPayload = payload.filter((entry) => {
      if (!uniqueNames.has(entry.value)) {
        uniqueNames.add(entry.value);
        return true;
      }
      return false;
    });

    return (
      <ul
        className="legendItems"
        style={{
          listStyle: "none",
          padding: "10px",
          margin: "10px ",

          width: 260,
        }}
      >
        {filteredPayload.map((entry, index) => (
          <li
            key={`item-${index}`}
            onMouseEnter={(e) => onPieEnter(e, index)}
            onMouseLeave={(e) => onPieLeave(e, index)}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 25,
              fontSize: 14,
            }}
          >
            {/* Left Side */}
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div
                style={{
                  width: 14,
                  height: 14,
                  backgroundColor: entry.color,
                }}
              />

              <span
                style={{
                  color: "#666",
                  fontWeight: 500,
                }}
              >
                {entry.value}
              </span>
            </div>

            {/* Right Side Value */}
            <span
              style={{
                fontWeight: 700,
                color: "#000",
              }}
            >
              {entry.payload.pv}
            </span>
          </li>
        ))}
      </ul>
    );
  };
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{
            padding: "14px 28px",
            // backgroundColor: "#fff",
            // borderRadius: "8px",
            // boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.25)",
          }}
        >
          <div
            // className="InnerUsers col-md-6"
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            {RoleBased != undefined ? (
              <h2 class="user-name mb-0 WelcomeContent">{`Welcome ${capitalizeFirstLetter(
                RoleBased,
              )}! `}</h2>
            ) : null}
            {/* <ul class="breadcrumb">
              <li class="breadcrumb-item">Overview</li>
            </ul> */}
          </div>
          <div className="col-sm-3 SelectedDate" style={{}}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px", width: "100%" }}
            >
              Select Date
              <span style={{ color: "red" }}>*</span>
            </label>

            <div className="datepicker_dash">
              <DateRangePicker
                onOpen={() => {
                  setTimeout(() => {
                    alignDateRangePicker(dateRangeRef.current);
                  }, 80);
                }}
                editable={false} // ✅ FULLY disables typing & arrow keys
                style={{
                  width: "100%",
                  padding: "0px 5px",
                }}
                ref={dateRangeRef}
                defaultValue={
                  state.EmployeeVerificationsNeed.FROMDATE == ""
                    ? [
                        // new Date(new Date().setDate(today.getDate() - 30)),
                        // new Date(),
                        // new Date(),
                        // new Date(state.EmployeeVerificationsNeed.FROMDATE),
                        // new Date(state.EmployeeVerificationsNeed.TODATE),
                        new Date(range[0]),
                        new Date(range[1]),
                      ]
                    : [
                        // new Date(new Date().setDate(today.getDate() - 30)),
                        // new Date(),
                        // new Date(),

                        new Date(state.EmployeeVerificationsNeed.FROMDATE),
                        new Date(state.EmployeeVerificationsNeed.TODATE),
                      ]
                }
                disabledDate={(date) => isAfter(date, new Date())}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                // style={{ width: 270, padding: 10 }}
                // onClean={(e) => cleaningrange(e)}
                onClean={false}
                onChange={(e) => {
                  if (e != null) {
                    setrange([]);
                    e.forEach((newValue) => {
                      var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                      var localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      // "validtill",
                      handlechangedate(localISOTime);
                    });
                  }

                  // if (e != null && e.length === 2) {
                  //   const [startDate, endDate] = e;
                  //   const diffDays = differenceInDays(endDate, startDate);
                  //   if (diffDays === 30) {
                  //     // Since we are using inclusive range, difference should be 30 for 31 days
                  //     setrange([]);
                  //     e.forEach((newValue) => {
                  //       const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                  //       const localISOTime = new Date(newValue - tzoffset)
                  //         .toISOString()
                  //         .slice(0, -1);
                  //       handlechangedate(localISOTime);
                  //     });
                  //   } else if (diffDays < 30) {
                  //     setrange([]);
                  //     e.forEach((newValue) => {
                  //       const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                  //       const localISOTime = new Date(newValue - tzoffset)
                  //         .toISOString()
                  //         .slice(0, -1);
                  //       handlechangedate(localISOTime);
                  //     });
                  //   } else {
                  //     toast.error("Please select a range of exactly 31 days.", {
                  //       position: toast.POSITION.TOP_RIGHT,
                  //     });
                  //   }
                  // }
                }}
                onSelect={(e) => {
                  if (e && e.length === 1) {
                    setStartDate(e[0]);
                  }
                }}
              />
            </div>
          </div>
        </div>
        <div
          className=" row Filters "
          style={{
            marginRight: "0px",
            marginLeft: "0px",
            padding: "0px 30px",
            zIndex: "89",
            marginTop: "14px ",
            // backgroundColor: "#fff",
            // borderRadius: "8px",
            // boxShadow: "0px 0px 2px 4px rgba(0, 0, 0, 0.25)",
          }}
        >
          <div
            className="col-sm-3"
            style={{ marginTop: "-19px", zIndex: "99" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              State
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect({ value: "", label: "All" });
                console.log(e, "jjk9090");
              }}
              value={multiselect}
              labelledBy="Select"
              // placeholder={"Search"}
            />
          </div>

          <div className="col-sm-3" style={{ marginTop: "-19px" }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Region
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              // isClearable={multiselect1 != null && multiselect1?.label == "ALL" || multiselect1?.label =="All" ?  false :
              //   true}
              isClearable={
                multiselect1
                  ? Array.isArray(multiselect1)
                    ? multiselect1.some(
                        (item) => item.label === "ALL" || item.label === "All",
                      )
                      ? false
                      : true
                    : multiselect1.label === "ALL" ||
                        multiselect1.label === "All"
                      ? false
                      : true
                  : true
              }
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
              // placeholder={
              //   datas.state == ""
              //     ? "without selected state you can't select Region"
              //     : "search"
              // }
            />
          </div>

          <div
            className="col-sm-3"
            style={{ zIndex: "20", marginTop: "-19px" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Organization
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onChange={(e) => {
                handlOrganizationList(e);
              }}
              options={Organization_options}
              labelledBy="Select"
              onInputChange={handleInputOrganization}
              isClearable={
                state?.DashboardCall?.DashboardOrganizationSelcetdList
                  ? Array.isArray(
                      state?.DashboardCall?.DashboardOrganizationSelcetdList,
                    )
                    ? state?.DashboardCall?.DashboardOrganizationSelcetdList.some(
                        (item) => item.label === "ALL" || item.label === "All",
                      )
                      ? false
                      : true
                    : state?.DashboardCall?.DashboardOrganizationSelcetdList
                          .label === "ALL" ||
                        state?.DashboardCall?.DashboardOrganizationSelcetdList
                          .label === "All"
                      ? false
                      : true
                  : true
              }
              value={state?.DashboardCall?.DashboardOrganizationSelcetdList}
            />
          </div>

          <div
            className="col-sm-3"
            style={{ zIndex: "20", marginTop: "-19px" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Client
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // onSelect={(e) => {
              //   if (e != null) {
              //     SetSelectValue(e);
              //     dispatch(SetTheDashboardClientList(e));
              //   }
              // }}
              filterOption={() => true}
              onChange={(e) => {
                HandleClientBranches(e);
              }}
              options={nameList4}
              labelledBy="Select"
              onInputChange={HandleInputBranch}
              isClearable={
                state.DashboardCall.DashboardCLientList
                  ? Array.isArray(state.DashboardCall.DashboardCLientList)
                    ? state.DashboardCall.DashboardCLientList.some(
                        (item) => item.label === "ALL" || item.label === "All",
                      )
                      ? false
                      : true
                    : state.DashboardCall.DashboardCLientList.label === "ALL" ||
                        state.DashboardCall.DashboardCLientList.label === "All"
                      ? false
                      : true
                  : true
              }
              isDisabled={filterForWhite.white_collar ? true : false}
              // isMulti
              value={state.DashboardCall.DashboardCLientList}
            />
          </div>
        </div>

        <div className="newDashBodyContainer">
          <div className="newDashLeftContainerBody">
            <div className="newDashLeftContainerHeader">
              <h3>ONBOARDING</h3>
              <div className="borderDiveLeft"></div>
            </div>
            <div className="newDashLeftContainerTabs">
              <div
                className="newDashLeftContainerButtonTabs"
                style={{
                  backgroundColor:
                    onBoardTabs == "Total Employees" ? "#234492" : "#C0E7FA",
                  color:
                    onBoardTabs == "Total Employees" ? "#ffffff" : "#234492",
                }}
                onClick={() => {
                  setOnBoardTabs("Total Employees");
                }}
              >
                <div
                  className="newDashLeftContainerButtonTabsIcon"
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                  onClick={() => {
                    setGraph(false);
                  }}
                >
                  <img
                    src={
                      onBoardTabs == "Total Employees"
                        ? onBoardProfileWhiteIcon
                        : onBoardProfileBlueIcon
                    }
                  />
                  {console.log(graph, "kldslkakjldjaslskjd")}
                  <span className="newDashbLeftContainerButtonTitle">
                    Total Employees
                  </span>
                </div>
                <span className="newDashLeftContainerButtonTabsCount">500</span>
              </div>
              <div
                className="newDashLeftContainerButtonTabs"
                style={{
                  backgroundColor:
                    onBoardTabs == "Total Employees" ? "#C0E7FA" : "#234492",
                  color:
                    onBoardTabs == "Total Employees" ? "#234492" : "#ffffff",
                }}
                onClick={() => {
                  setOnBoardTabs("Relievers");
                }}
              >
                <div
                  className="newDashLeftContainerButtonTabsIcon"
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                  onClick={() => {
                    setGraph(true);
                  }}
                >
                  <img
                    src={
                      onBoardTabs == "Total Employees"
                        ? onBoardProfileBlueIcon
                        : onBoardProfileWhiteIcon
                    }
                  />
                  <span className="newDashbLeftContainerButtonTitle">
                    Relievers
                  </span>
                </div>
                <span className="newDashLeftContainerButtonTabsCount">50</span>
              </div>
            </div>
            <div className="newDashLeftContainerCards">
              {leftOnboardCards.map((item) => {
                return (
                  <div className="newDashLeftContainerCard">
                    <div className="newDashLeftContainerCardIcon">
                      <span>{item.title}</span>
                      <img src={item.icon} />
                    </div>
                    <span className="newDashLeftContainerCardCount">
                      {item.count}
                    </span>
                  </div>
                );
              })}
            </div>
            <h3 className="newDashLeftContainerTableHeader">
              {graph ? "Graph" : "ALL TOP ONBOARDINGS"}
            </h3>
            <div className="borderDiveLeft"></div>
            {graph ? (
              <PieChart width={750} height={330}>
                <Tooltip content={CustomTooltip} />

                <Legend
                  layout="vertical"
                  align="right"
                  verticalAlign="middle"
                  wrapperStyle={{ top: "81px" }}
                  content={renderLegend}
                />
                <Pie
                  data={graphData}
                  dataKey="pv"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  innerRadius={30}
                  activeIndex={activeIndex}
                  activeShape={renderActiveShape}
                  onMouseEnter={onPieEnter}
                  onMouseLeave={onPieLeave}
                  isAnimationActive={true}
                  cornerRadius={3}
                  // label
                >
                  {graphData.map((entry, index) => {
                    return (
                      <>
                        <Cell
                          key={`cell-${index}`}
                          fill={chartColorList[index % chartColorList.length]}
                          style={{ transition: "all 0.3s ease-in-out" }}
                        />
                      </>
                    );
                  })}
                </Pie>
                <Pie
                  data={graphData}
                  dataKey="pv"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  innerRadius={20}
                  outerRadius={27}
                  // cornerRadius={5}

                  paddingAngle={3}
                  legendType="none"

                  // label
                >
                  <>
                    {" "}
                    {graphData.map((entry, index) => {
                      return (
                        <>
                          <Cell
                            key={`cell-${index}`}
                            fill={chartColorList[index % chartColorList.length]}
                          />
                        </>
                      );
                    })}
                  </>
                </Pie>
              </PieChart>
            ) : (
              <table className="newDashLeftContainerTable">
                <thead>
                  <tr>
                    <th>Position</th>
                    <th>State</th>
                    <th>Employees</th>
                  </tr>
                </thead>
                <tbody>
                  {onBoardStateList.map((item) => {
                    return (
                      <tr>
                        <td>
                          <span
                            style={{
                              backgroundColor: "#E8E8E8",
                              padding: "5px 8px",
                              borderRadius: "5px",
                              width: "30px",
                            }}
                          >
                            {item.id}
                          </span>
                        </td>
                        <td>{item.state}</td>
                        <td>{item.employees}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
          <div className="newDashRightContainerBody">
            <div className="newDashRightContainerHeader">
              <h3>ATTENDENCE</h3>
              <div className="borderDiveRight"></div>
              <div className="newDashLeftContainerCards">
                {rightOnboardCards.map((item) => {
                  return (
                    <div className="newDashLeftContainerCard">
                      <div className="newDashLeftContainerCardIcon">
                        <span>{item.title}</span>
                        <img src={item.icon} />
                      </div>
                      <span className="newDashLeftContainerCardCount">
                        {item.count}
                      </span>
                    </div>
                  );
                })}
              </div>
              <h3
                className="newDashLeftContainerTableHeader"
                style={{ fontSize: "14px" }}
              >
                {graph ? "Graph" : "ALL TOP ABSENTEES"}
              </h3>
              <div className="borderDiveRight"></div>
              {graph ? (
                <div style={{ width: "100%", height: 420 }}>
                  <ResponsiveContainer>
                    <LineChart
                      data={data}
                      margin={{ top: 40, right: 20, left: 30, bottom: 40 }}
                    >
                      <XAxis
                        dataKey="day"
                        axisLine={false}
                        tickLine={false}
                        tick={{ fill: "#000", fontSize: 14 }} // black text
                      />

                      <YAxis hide domain={[0, "dataMax + 10"]} />

                      <Tooltip
                        cursor={false}
                        contentStyle={{
                          borderRadius: "6px",
                          border: "none",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        }}
                      />

                      <Line
                        type="monotone"
                        dataKey="value"
                        stroke="#f57c00"
                        strokeWidth={3}
                        dot={<CustomDot />}
                        activeDot={{ r: 8, fill: "#e64a19" }}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              ) : (
                <table className="newDashLeftContainerTable">
                  <thead>
                    <tr>
                      <th>Position</th>
                      <th>State</th>
                      <th>Percentage</th>
                    </tr>
                  </thead>
                  <tbody>
                    {onBoardAbsentList.map((item) => {
                      return (
                        <tr>
                          <td>
                            <span
                              style={{
                                backgroundColor: "#E8E8E8",
                                padding: "5px 8px",
                                borderRadius: "5px",
                              }}
                            >
                              {item.id}
                            </span>
                          </td>
                          <td>{item.state}</td>
                          <td>{item.percentage}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewDashboard;
